import classnames from 'classnames';
import React, { FC } from 'react';
import styles from './Separator.scss';
import { IOuter } from './Separator.types';

export const Separator: FC<IOuter> = ({ className, noMargin, dataHook }) => (
  <div className={classnames(styles.separator, noMargin && styles.noMargin, className)} data-hook={dataHook} />
);
